import { Component } from '@angular/core';

@Component({
  selector: 'app-exports-consistency-check',
  templateUrl: './exports-consistency-check.component.html',
  styleUrls: ['./exports-consistency-check.component.scss'],
})
export class ExportsConsistencyCheckComponent {}
